<vwui-header>
  <app-back-header (back)="navigateToProjectTypes()">
    <h2 a11yPageTitleLevel="1">{{ 'PAGE_PROJECT_TYPE.title' | translate }}</h2>
  </app-back-header>
</vwui-header>

@if (!loadingSpinnerService.isSpinnerVisible() && projectType(); as type) {
  <section class="project-type-section">
    <div class="project-type-section__header">
      <div>
        <h3 class="project-type-section__title">{{ type.name }}</h3>
        @if (type.description) {
          <p class="project-type-section__description">{{ type.description }}</p>
        }
      </div>
      <vwui-button class="is-secondary" (click)="openEditModal()">
        {{ 'PAGE_PROJECT_TYPE.edit' | translate }}
      </vwui-button>
    </div>
  </section>

  <section class="project-type-section">
    @if (versions().length === 0) {
      <div class="project-type-empty">
        <h4 class="project-type-empty__title">{{ 'PAGE_PROJECT_TYPE.versions.empty_title' | translate }}</h4>
        <p class="project-type-empty__description">{{ 'PAGE_PROJECT_TYPE.versions.empty' | translate }}</p>
        <div class="project-type-empty__actions">
          <vwui-button class="is-primary" (click)="createFirstVersion()">
            {{ 'PAGE_PROJECT_TYPE.versions.create_first' | translate }}
          </vwui-button>
          <vwui-button class="is-secondary" (click)="openCopyFromModal()">
            {{ 'PAGE_PROJECT_TYPE.versions.copy_from' | translate }}
          </vwui-button>
        </div>
      </div>
    } @else {
      <vwui-table [compactable]="false">
        <div slot="table-title">{{ 'PAGE_PROJECT_TYPE.versions.header' | translate }}</div>
        <vwui-table-row>
          <vwui-table-header class="project-type-version-col project-type-version-col--id">
            {{ 'PAGE_PROJECT_TYPE.versions.column.version' | translate }}
          </vwui-table-header>
          <vwui-table-header class="project-type-version-col project-type-version-col--status">
            {{ 'PAGE_PROJECT_TYPE.versions.column.status' | translate }}
          </vwui-table-header>
          <vwui-table-header class="project-type-version-col project-type-version-col--published">
            {{ 'PAGE_PROJECT_TYPE.versions.column.publishedAt' | translate }}
          </vwui-table-header>
          <vwui-table-header class="project-type-version-col project-type-version-col--actions">
          </vwui-table-header>
        </vwui-table-row>

        @for (version of versions(); track trackVersion($index, version)) {
          <vwui-table-row>
            <vwui-table-column class="project-type-version-col project-type-version-col--id">
              v{{ version.versionId }}
            </vwui-table-column>
            <vwui-table-column class="project-type-version-col project-type-version-col--status">
              <span
                class="project-type-status"
                [class.project-type-status--active]="version.isActive"
                [class.project-type-status--concept]="version.isConcept"
                [class.project-type-status--archived]="version.isArchived"
              >
                {{ 'PAGE_PROJECT_TYPE.versions.status.' + version.status | translate }}
              </span>
            </vwui-table-column>
            <vwui-table-column class="project-type-version-col project-type-version-col--published">
              @if (version.publishedAt) {
                {{ version.publishedAt | date:'dd-MM-yyyy' }}
              } @else {
                -
              }
            </vwui-table-column>
            <vwui-table-column class="project-type-version-col project-type-version-col--actions">
              @if (version.isConcept) {
                <vwui-btn-icon icon="vwui-check"
                               title="{{ 'PAGE_PROJECT_TYPE.versions.action.publish' | translate }}"
                               (click)="openPublishModal(version)"></vwui-btn-icon>
                <vwui-btn-icon icon="edit"
                               title="{{ 'PAGE_PROJECT_TYPE.versions.action.edit' | translate }}"
                               (click)="editVersion(version)"></vwui-btn-icon>
                <vwui-btn-icon icon="vwui-trash"
                               title="{{ 'PAGE_PROJECT_TYPE.versions.action.delete' | translate }}"
                               (click)="openDeleteVersionModal(version)"></vwui-btn-icon>
              } @else {
                  <vwui-btn-icon icon="preview"
                                 title="{{ 'PAGE_PROJECT_TYPE.versions.action.view' | translate }}"
                                 (click)="editVersion(version)"></vwui-btn-icon>
              }
            </vwui-table-column>
          </vwui-table-row>
        }
      </vwui-table>
    }
  </section>
}
